





import {Component, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import {throttle} from "@/design-system/utilities/Throttle"

/**
 * @changelog 4.3.1 Add comprehensive callback throttle.
 * @changelog 4.3.0 Released as part of Breakdown.
 */
@Component
export default class JdhSizeDetector extends Vue {
    @Ref() watchEl!: HTMLElement

    @Prop({default: false, type: Boolean}) emitResizes!: boolean
    @Prop({default: false, type: Boolean}) emitOverflows!: boolean

    observer?: null|ResizeObserver = null
    debouncedCallback = null

    overflowing = false
    lastOverflowEdge = 0

    mounted() {
        this.$nextTick(() => {
            if (!this.watchEl) return
            this.observer = new ResizeObserver(this.debouncedCallback)
            this.observer.observe(this.watchEl.parentElement)
        })

        this.debouncedCallback = throttle((entries: ResizeObserverEntry[]) => {
            for (let entry of entries) {
                this.checkResize(entry)
                this.checkOverflow()
            }
        }, 100)
    }

    updated(){
        this.$nextTick(() => {
            this.checkOverflow()
        })
    }

    checkOverflow(){
        // abort quickly if inop
        if (!this.emitOverflows || !this.watchEl) return

        // rising edge check
        if (this.watchEl.parentElement.scrollWidth > this.watchEl.parentElement.clientWidth &&!this.overflowing) {
            this.$emit('overflowStart')
            this.overflowing = true
            // record breakpoint to know when to restore it
            this.lastOverflowEdge = this.watchEl.parentElement.clientWidth
        }

        // falling edge check
        if (this.overflowing && this.lastOverflowEdge < this.watchEl.parentElement.clientWidth) {
            this.overflowing = false
            this.$emit('overflowEnd')
        }
    }

    checkResize(el: ResizeObserverEntry) {
        if (this.emitResizes) {
            this.$emit('resize', el.contentRect)
        }
    }

    beforeDestroy() {
        delete this.observer
    }
}
